/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Verify_VerifiedInputs */

const en_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`University verified`)
};

const de_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universität verifiziert`)
};

const fr_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Université vérifiée`)
};

const es_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universidad verificada`)
};

const it_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificato dall'università`)
};

const nl_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universiteit geverifieerd`)
};

const pl_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowany przez uczelnię`)
};

const fi_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yliopisto varmistettu`)
};

const da_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsverificeret`)
};

const sv_settings_verify_verified = /** @type {(inputs: Settings_Verify_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitet verifierat`)
};

/**
* | output |
* | --- |
* | "University verified" |
*
* @param {Settings_Verify_VerifiedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_verify_verified = /** @type {((inputs?: Settings_Verify_VerifiedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Verify_VerifiedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_verify_verified(inputs)
	if (locale === "fr") return fr_settings_verify_verified(inputs)
	if (locale === "es") return es_settings_verify_verified(inputs)
	if (locale === "it") return it_settings_verify_verified(inputs)
	if (locale === "nl") return nl_settings_verify_verified(inputs)
	if (locale === "pl") return pl_settings_verify_verified(inputs)
	if (locale === "fi") return fi_settings_verify_verified(inputs)
	if (locale === "da") return da_settings_verify_verified(inputs)
	if (locale === "sv") return sv_settings_verify_verified(inputs)
	return en_settings_verify_verified(inputs)
});